import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 获取公告信息 0 文件公告 1 会员服务信息
  async getNotice(params) {
    return request({
      method: POST,
      url: '/member/notice/list',
      params
    })
  },
}
